import React from "react";

function SearchIcon({
   
    className,
  }: IconPropsType) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="25"
      viewBox="0 0 25 25"
      className={className}
    >
      <path
        id="Path_99"
        d="M25,22.8,19.811,17.61a10.768,10.768,0,0,0,2.2-6.6A10.939,10.939,0,0,0,11.141,0h-.135A10.939,10.939,0,0,0,0,10.871v.135A10.939,10.939,0,0,0,10.871,22.012h.135a10.768,10.768,0,0,0,6.6-2.2L22.8,25ZM3.145,11.006a7.785,7.785,0,0,1,7.707-7.862h.154a7.785,7.785,0,0,1,7.862,7.707v.154a7.785,7.785,0,0,1-7.707,7.862h-.154A7.785,7.785,0,0,1,3.145,11.16Z"
        transform="translate(0 0)"
        fill="#fff"
      />
    </svg>
  );
}

export default SearchIcon;
type IconPropsType = {
    color?: string;
    fill?: string;
    className?: string;
  };
  